import React from "react";
import Button from "../Button";
import "./ConfirmLeavePageModal.css";

const ConfirmLeavePageModal = (props) => {
  return (
      <div
          className="content-area"
          id="content-area-container"
          style={{
              background: "white",
              boxShadow: "rgb(136, 136, 136) 0px 0px 8px 3px",
          }}
      >
          <div id="content-area">
              <div className="content_layout_fe">
                  <header className="header_fe">Profile Not Complete Warning</header>

                  <div>
                      <p className="content_fe">
                          Please complete your Profile.
                      </p>

                      <div className="button-group">
                          <Button action="primary" label="OK" onClick={props.accept}/>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  );
};

export default ConfirmLeavePageModal;
